export const ADD_CLIENT = 'ADD_CLIENT';
export const SET_CONTACT = 'SET_CONTACT';
export const SET_CLIENT = 'SET_CLIENT';
export const EDIT_CLIENT = 'EDIT_CLIENT';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const SET_CLIENT_COURANT = 'SET_CLIENT_COURANT';
export const SET_TOTAL_CONTACTS = 'SET_TOTAL_CONTACTS';
export const SET_TOTAL_CLIENTS = 'SET_TOTAL_CLIENTS';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_PLACE_INTERVENANT = 'SET_PLACE_INTERVENANT';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_LAST_PAYLOAD_CONCTAT = 'SET_LAST_PAYLOAD_CONCTAT';
